import React from 'react';
import { useNavigate } from 'react-router-dom';
import socket from '../socket';
import Wocaicai_medal_01 from '../assets/images/Wocaicai_medal-01.png';
import Wocaicai_medal_02 from '../assets/images/Wocaicai_medal-02.png';
import Wocaicai_medal_03 from '../assets/images/Wocaicai_medal-03.png';

const GameOver = ({ role, gameSyncData, player, gameHistory }) => {
    const navigate = useNavigate();

  const handlePlayAgain = () => {
    if (role === 'host' && gameSyncData?.gameOver ) {
      socket.emit('play-again', gameSyncData?.roomId);
    }
  };

  const goHome = () => {
    navigate('/');

    if (gameSyncData?.roomId && player?.id) {
      socket.emit('go-lobby', {
        roomId: gameSyncData.roomId,
        playerId: player.id,
      });
    }
  };

  if (gameHistory.length === 0) return null;

  const isTeamMode =
    gameHistory[0].teamScores &&
    Object.keys(gameHistory[0].teamScores).length > 0;

  let totalScores = {};

  if (isTeamMode) {
    totalScores = gameHistory.reduce((totals, round) => {
      for (const team in round.teamScores) {
        totals[team] = (totals[team] || 0) + round.teamScores[team];
      }
      return totals;
    }, {});
  } else {
    totalScores = gameHistory.reduce((totals, round) => {
      for (const player of round.playerScores) {
        totals[player.name] = (totals[player.name] || 0) + player.score;
      }
      return totals;
    }, {});
  }

  const sortedScores = [...Object.entries(totalScores)].sort(
    (a, b) => b[1] - a[1]
  );

  if (sortedScores.length === 0) return null;

  const podiumStyle = 'bg-gradient-to-b from-[#3467C3] to-transparent rounded-t-xl flex items-end justify-center text-white font-bold';

  const medals = [Wocaicai_medal_01, Wocaicai_medal_02, Wocaicai_medal_03];

  const getPodiumBlock = ([name, score], height, index) => (
  <div className="relative flex flex-col items-center w-[30vw] max-w-[14rem] sm:max-w-[18rem] justify-end">
    
    {/* Medal - absolute and overlapping */}
      {index <= 2 && (
        <img
          src={medals[index]}
          alt={`Medal ${index + 1}`}
          className={`absolute z-10 w-12 sm:w-16
            ${index === 0 ? 'top-[5.5vh]' : ''}
            ${index === 1 ? 'top-[14vh]' : ''}
            ${index === 2 ? 'top-[25vh]' : ''}
          `}
        />
      )}


    {/* Name (with padding to avoid overlap with medal) */}
    <div className="p-3 sm:p-5 w-full rounded-full mb-4 text-center text-indigo-200 font-semibold text-sm sm:text-lg bg-[#022E7E] notranslate truncate max-w-[16rem]" translate="no">
      {name}
    </div>

    {/* Podium Block */}
    <div
      className={`${podiumStyle} text-xs sm:text-base`}
      style={{
        height,
        width: '100%',
        background: 'linear-gradient(180deg, #3467C3 0%, rgba(0, 73, 205, 0) 148.13%)',
      }}
    >
      <span className="mt-[3rem] self-start text-[#FFCC21] text-center notranslate text-sm sm:text-xl" translate="no">
        {score} <br /> Points
      </span>
    </div>
  </div>
);


  const podiumBlocks = [];

  if (sortedScores.length >= 2) {
    podiumBlocks.push(getPodiumBlock(sortedScores[1], '75%', 1)); // 🥈
  }

  podiumBlocks.push(getPodiumBlock(sortedScores[0], '100%', 0)); // 🥇

  if (sortedScores.length >= 3) {
    podiumBlocks.push(getPodiumBlock(sortedScores[2], '60%', 2)); // 🥉
  }

  const orderedPodium = [];

  if (podiumBlocks.length === 2) {
    orderedPodium.push(podiumBlocks[1]);
    orderedPodium.push(podiumBlocks[0]);
  } else {
    orderedPodium.push(podiumBlocks[0]); // 2nd
    orderedPodium.push(podiumBlocks[1]); // 1st
    orderedPodium.push(podiumBlocks[2]); // 3rd
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-20">
      <div className="bg-gameOver px-4 sm:px-6 flex justify-center items-end relative backdrop-blur-md rounded-xl w-full h-full overflow-y-auto shadow-xl transition-all duration-300 animate-fade-in text-black">
        <div className="w-full flex justify-center gap-2 sm:gap-6 h-[70vh] mb-6">
          {orderedPodium}
        </div>
         {/* Return Button - absolutely positioned at bottom center */}

    {/* Stacked Buttons at Bottom Center */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-3 z-30">

        {role === 'host' && gameSyncData?.gameOver && (
          <button
            className="font-bold flex-1 relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
            bg-[#FFCC21] rounded-2xl shadow-[0_6px_0_0_#FFA600]
            transition-all duration-150 ease-in-out
            hover:scale-[1.03]
            hover:brightness-110
            active:translate-y-[4px] active:shadow-none"
            onClick={handlePlayAgain}
          >
            Play Again
          </button>
        )}

          <button
            className="font-bold flex-1 relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
            bg-[#FF1111] rounded-2xl shadow-[0_6px_0_0_#C30F0F]
            transition-all duration-150 ease-in-out
            hover:scale-[1.03]
            hover:brightness-110
            active:translate-y-[4px] active:shadow-none"
            onClick={goHome}
          >
            Return to Home
          </button>
      </div>

      </div>
    </div>
  );
};

export default GameOver;
